'use strict';

$('select[data-init-plugin="cs-select"]').on('change', function() {
    var selectName = $(this).attr('name');
    var form = $('[data-cs-name="' + selectName + '"]').closest('form');

    setTimeout(function() {
        form.submit();
    }, 50);
});
